export function withTimeout(operation, timeoutMs = 30000) {
  const controller = new AbortController();
  let timer;
  const timeout = new Promise((resolve, reject) => {
    timer = setTimeout(() => {
      controller.abort();
      reject(new Error("The request timed out. Please try again."));
    }, timeoutMs);
  });
  return Promise.race([Promise.resolve().then(() => operation(controller.signal)), timeout])
    .finally(() => clearTimeout(timer));
}

export function requestJson(path, token, options = {}) {
  if (!path.startsWith("/api/")) return Promise.reject(new Error("Invalid API path."));
  return withTimeout(async (signal) => {
    const response = await fetch(path, {
      ...options,
      signal,
      credentials: "same-origin",
      headers: { ...options.headers, Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
      const error = new Error(response.status === 401
        ? "Your session has expired. Please sign in again."
        : "Unable to complete the request. Please try again.");
      error.status = response.status;
      throw error;
    }
    return response.json();
  });
}
